export const last = <T>(arr: T[]): T => arr[arr.length - 1];
